import type * as Types from '@hotelplan/supergraph-api';

import type { DocumentNode } from 'graphql';
import { FdrAllBlogArticlesResponseFragmentDoc } from 'schemas/fragment/blog-articles/fdr-all-blog-articles.generated';
import type * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@hotelplan/fdr.lib.apollo.query';
const defaultOptions = {} as const;
export type FdrGeoBlogArticlesQueryVariables = Types.Exact<{
  input: Types.FdrGeoInput;
  blogCriteria: Array<Types.FdrImageCriteria> | Types.FdrImageCriteria;
  blogArticleInput: Types.FdrAllBlogArticlesInput;
}>;

export type FdrGeoBlogArticlesQuery = {
  __typename?: 'Query';
  fdrGeo?:
    | {
        __typename: 'FdrContinent';
        id: string;
        relatedBlogArticles: {
          __typename?: 'FdrAllBlogArticlesResponse';
          blogArticles?: Array<{
            __typename?: 'FdrBlogArticle';
            publicId: string;
            title?: string | null;
            text?: string | null;
            start?: any | null;
            flagline?: string | null;
            webMeta: {
              __typename?: 'FdrMeta';
              title: string;
              description: string;
              index: boolean;
              noFollow: boolean;
              sitemap: boolean;
              link: {
                __typename?: 'FdrLink';
                openMethod?: Types.FdrLinkOpenMethod | null;
                legacyUrl?: string | null;
                type: Types.FdrLinkType;
                url: string;
              };
            };
            hero?: {
              __typename?: 'FdrImage';
              resized: Array<{
                __typename?: 'FdrResizedImage';
                id: string;
                link: {
                  __typename?: 'FdrLink';
                  openMethod?: Types.FdrLinkOpenMethod | null;
                  legacyUrl?: string | null;
                  type: Types.FdrLinkType;
                  url: string;
                };
              }>;
            } | null;
            employee?: {
              __typename?: 'FdrEmployee';
              name: string;
              image?: {
                __typename?: 'FdrImage';
                resized: Array<{
                  __typename?: 'FdrResizedImage';
                  id: string;
                  link: {
                    __typename?: 'FdrLink';
                    openMethod?: Types.FdrLinkOpenMethod | null;
                    legacyUrl?: string | null;
                    type: Types.FdrLinkType;
                    url: string;
                  };
                }>;
              } | null;
            } | null;
          }> | null;
          pagination: {
            __typename?: 'FdrPagination';
            total: number;
            page: number;
            perPage: number;
          };
        };
      }
    | {
        __typename: 'FdrCountry';
        id: string;
        relatedBlogArticles: {
          __typename?: 'FdrAllBlogArticlesResponse';
          blogArticles?: Array<{
            __typename?: 'FdrBlogArticle';
            publicId: string;
            title?: string | null;
            text?: string | null;
            start?: any | null;
            flagline?: string | null;
            webMeta: {
              __typename?: 'FdrMeta';
              title: string;
              description: string;
              index: boolean;
              noFollow: boolean;
              sitemap: boolean;
              link: {
                __typename?: 'FdrLink';
                openMethod?: Types.FdrLinkOpenMethod | null;
                legacyUrl?: string | null;
                type: Types.FdrLinkType;
                url: string;
              };
            };
            hero?: {
              __typename?: 'FdrImage';
              resized: Array<{
                __typename?: 'FdrResizedImage';
                id: string;
                link: {
                  __typename?: 'FdrLink';
                  openMethod?: Types.FdrLinkOpenMethod | null;
                  legacyUrl?: string | null;
                  type: Types.FdrLinkType;
                  url: string;
                };
              }>;
            } | null;
            employee?: {
              __typename?: 'FdrEmployee';
              name: string;
              image?: {
                __typename?: 'FdrImage';
                resized: Array<{
                  __typename?: 'FdrResizedImage';
                  id: string;
                  link: {
                    __typename?: 'FdrLink';
                    openMethod?: Types.FdrLinkOpenMethod | null;
                    legacyUrl?: string | null;
                    type: Types.FdrLinkType;
                    url: string;
                  };
                }>;
              } | null;
            } | null;
          }> | null;
          pagination: {
            __typename?: 'FdrPagination';
            total: number;
            page: number;
            perPage: number;
          };
        };
      }
    | {
        __typename: 'FdrCountryGroup';
        id: string;
        relatedBlogArticles: {
          __typename?: 'FdrAllBlogArticlesResponse';
          blogArticles?: Array<{
            __typename?: 'FdrBlogArticle';
            publicId: string;
            title?: string | null;
            text?: string | null;
            start?: any | null;
            flagline?: string | null;
            webMeta: {
              __typename?: 'FdrMeta';
              title: string;
              description: string;
              index: boolean;
              noFollow: boolean;
              sitemap: boolean;
              link: {
                __typename?: 'FdrLink';
                openMethod?: Types.FdrLinkOpenMethod | null;
                legacyUrl?: string | null;
                type: Types.FdrLinkType;
                url: string;
              };
            };
            hero?: {
              __typename?: 'FdrImage';
              resized: Array<{
                __typename?: 'FdrResizedImage';
                id: string;
                link: {
                  __typename?: 'FdrLink';
                  openMethod?: Types.FdrLinkOpenMethod | null;
                  legacyUrl?: string | null;
                  type: Types.FdrLinkType;
                  url: string;
                };
              }>;
            } | null;
            employee?: {
              __typename?: 'FdrEmployee';
              name: string;
              image?: {
                __typename?: 'FdrImage';
                resized: Array<{
                  __typename?: 'FdrResizedImage';
                  id: string;
                  link: {
                    __typename?: 'FdrLink';
                    openMethod?: Types.FdrLinkOpenMethod | null;
                    legacyUrl?: string | null;
                    type: Types.FdrLinkType;
                    url: string;
                  };
                }>;
              } | null;
            } | null;
          }> | null;
          pagination: {
            __typename?: 'FdrPagination';
            total: number;
            page: number;
            perPage: number;
          };
        };
      }
    | { __typename: 'FdrDestination'; id: string }
    | {
        __typename: 'FdrRegion';
        id: string;
        relatedBlogArticles: {
          __typename?: 'FdrAllBlogArticlesResponse';
          blogArticles?: Array<{
            __typename?: 'FdrBlogArticle';
            publicId: string;
            title?: string | null;
            text?: string | null;
            start?: any | null;
            flagline?: string | null;
            webMeta: {
              __typename?: 'FdrMeta';
              title: string;
              description: string;
              index: boolean;
              noFollow: boolean;
              sitemap: boolean;
              link: {
                __typename?: 'FdrLink';
                openMethod?: Types.FdrLinkOpenMethod | null;
                legacyUrl?: string | null;
                type: Types.FdrLinkType;
                url: string;
              };
            };
            hero?: {
              __typename?: 'FdrImage';
              resized: Array<{
                __typename?: 'FdrResizedImage';
                id: string;
                link: {
                  __typename?: 'FdrLink';
                  openMethod?: Types.FdrLinkOpenMethod | null;
                  legacyUrl?: string | null;
                  type: Types.FdrLinkType;
                  url: string;
                };
              }>;
            } | null;
            employee?: {
              __typename?: 'FdrEmployee';
              name: string;
              image?: {
                __typename?: 'FdrImage';
                resized: Array<{
                  __typename?: 'FdrResizedImage';
                  id: string;
                  link: {
                    __typename?: 'FdrLink';
                    openMethod?: Types.FdrLinkOpenMethod | null;
                    legacyUrl?: string | null;
                    type: Types.FdrLinkType;
                    url: string;
                  };
                }>;
              } | null;
            } | null;
          }> | null;
          pagination: {
            __typename?: 'FdrPagination';
            total: number;
            page: number;
            perPage: number;
          };
        };
      }
    | { __typename: 'FdrResort'; id: string }
    | null;
};

export const FdrGeoBlogArticlesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FdrGeoBlogArticles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FdrGeoInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'blogCriteria' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'FdrImageCriteria' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'blogArticleInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FdrAllBlogArticlesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fdrGeo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'publicId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrContinent' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedBlogArticles' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'blogArticleInput' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'fdrAllBlogArticlesResponse',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrCountryGroup' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedBlogArticles' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'blogArticleInput' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'fdrAllBlogArticlesResponse',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrCountry' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedBlogArticles' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'blogArticleInput' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'fdrAllBlogArticlesResponse',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrRegion' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedBlogArticles' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'blogArticleInput' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'fdrAllBlogArticlesResponse',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...FdrAllBlogArticlesResponseFragmentDoc.definitions,
  ],
} as unknown as DocumentNode;

/**
 * __useFdrGeoBlogArticlesQuery__
 *
 * To run a query within a React component, call `useFdrGeoBlogArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFdrGeoBlogArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFdrGeoBlogArticlesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      blogCriteria: // value for 'blogCriteria'
 *      blogArticleInput: // value for 'blogArticleInput'
 *   },
 * });
 */
export function useFdrGeoBlogArticlesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FdrGeoBlogArticlesQuery,
    FdrGeoBlogArticlesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    FdrGeoBlogArticlesQuery,
    FdrGeoBlogArticlesQueryVariables
  >(FdrGeoBlogArticlesDocument, options);
}
export function useFdrGeoBlogArticlesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FdrGeoBlogArticlesQuery,
    FdrGeoBlogArticlesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    FdrGeoBlogArticlesQuery,
    FdrGeoBlogArticlesQueryVariables
  >(FdrGeoBlogArticlesDocument, options);
}
export type FdrGeoBlogArticlesQueryHookResult = ReturnType<
  typeof useFdrGeoBlogArticlesQuery
>;
export type FdrGeoBlogArticlesLazyQueryHookResult = ReturnType<
  typeof useFdrGeoBlogArticlesLazyQuery
>;
export type FdrGeoBlogArticlesQueryResult = Apollo.QueryResult<
  FdrGeoBlogArticlesQuery,
  FdrGeoBlogArticlesQueryVariables
>;
